import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import useClickAwayListener from '@shared/hooks/useClickAwayListener';
import CustomDropdown from '@components/CustomDropdown/CustomDropdown';
import Dots from '@assets/icons/three-dots.svg';
import styles from './ThreeDotsDropdown.module.scss';

const ThreeDotsDropdown = ({ items, onSelect }) => {
  const [isOpen, setIsOpen] = useState();

  const dropdownRef = useRef();
  useClickAwayListener(dropdownRef, () => setIsOpen(false));

  const onClick = event => {
    event.stopPropagation();
    setIsOpen(prev => !prev);
  };

  return (
    <div style={{ position: 'relative' }} ref={dropdownRef}>
      <button onClick={onClick} className={styles.button}>
        <Dots />
      </button>
      <CustomDropdown
        items={items}
        open={isOpen}
        setIsOpen={setIsOpen}
        onSelect={onSelect}
        minWidth={162}
      />
    </div>
  );
};

ThreeDotsDropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      icon: PropTypes.node,
    }),
  ),
  onSelect: PropTypes.func,
};

export default ThreeDotsDropdown;
